import { Column, Heading, Image, Paragraph } from "@hex-insights/core";
import { MailLink, useActivePageRegistration } from "@hex-insights/router";
import { ButtonLink, StaticURLs } from "@hex-insights/verita-romania.shared";
import { homePageInfo } from "../../Home/pageinfo";
import { ReEnrollmentLayout } from "../Components";
import { reEnrollmentSuccessPageInfo } from "./pageinfo";
import generalStyles from "../general.module.css";
import styles from "./styles.module.css";

export function ReEnrollmentSuccessPage() {
	useActivePageRegistration(reEnrollmentSuccessPageInfo);

	return (
		<ReEnrollmentLayout>
			<Column justify="spaced-start" align="center" verticalSpacing="2rem" className={styles["main-content"]}>
				<Image src={StaticURLs.Images.veritaLogoAndWordmark} sizing="width-scaled" style={{ width: "12.5rem" }} />

				<Heading.H1 noMargin className={generalStyles["heading"] + " " + styles["heading--level-1"]}>
					Thank you!
				</Heading.H1>

				<Column justify="spaced-start" verticalSpacing="1rem">
					<Heading.H2 noMargin className={generalStyles["heading"]}>
						Your choices have been successfully submitted.
					</Heading.H2>

					<Paragraph style={{ margin: 0 }}>We will now review your information to generate your contract.</Paragraph>

					<Paragraph style={{ margin: 0 }}>
						After <strong>21 March</strong>, a copy of your contract will be provided for you to download, sign and
						return. More information will be provided in the coming days.
					</Paragraph>

					<Paragraph style={{ margin: 0 }}>
						In the meantime, if you have any questions please contact the Finance Department directly via the portal or
						by email: <MailLink email="finance@verita.ro">finance@verita.ro</MailLink>.
					</Paragraph>
				</Column>

				<ButtonLink variant="primary" to={homePageInfo.to} className={styles["action-button"]}>
					Exit to Portal
				</ButtonLink>
			</Column>
		</ReEnrollmentLayout>
	);
}
